import { ChangeEvent, useContext, VFC } from "react";
// Libraries
import { sortBy } from "lodash";
// API
import { GetActivityTemplates_activityTemplates } from "api/MyLivestock/Activity/types/GetActivityTemplates";
// Utils
import { CommonContext } from "config/commonProvider";
import { useGetActivityTemplates, useGetActivityTypes } from "hooks";
// Components
import { InputSelect } from "components";
import { InputSelectOptionWithTitles } from "components/Common/Field/Select";

interface ImportWizardActivityTemplateSelectProps {
  activityTemplate: GetActivityTemplates_activityTemplates;
  onChangeActivityTemplate: (activityTemplate: GetActivityTemplates_activityTemplates) => void;
}

export const ImportWizardActivityTemplateSelect: VFC<ImportWizardActivityTemplateSelectProps> = ({
  activityTemplate: activityTemplateActive,
  onChangeActivityTemplate,
}) => {
  const { data: activityTypes } = useGetActivityTypes();
  const { data: activityTemplates } = useGetActivityTemplates();

  const activityTemplatesOptions = activityTypes.reduce<InputSelectOptionWithTitles[]>((accumulator, activityType) => {
    const activityTemplatesWithinType = sortBy(
      activityTemplates.filter((activityTemplate) => activityTemplate.activityType?.id === activityType.id),
      ["name"],
    );

    if (activityTemplatesWithinType.length) {
      accumulator.push({
        key: activityType.id,
        label: activityType.name,
      });

      activityTemplatesWithinType.forEach((activityTemplate) => {
        accumulator.push({
          key: activityTemplate.id,
          value: activityTemplate.id,
          label: activityTemplate.name,
        });
      });
    }

    return accumulator;
  }, []);

  const { showNotification } = useContext(CommonContext);
  const handleChangeActivityTemplate = (event: ChangeEvent<HTMLSelectElement>) => {
    const newActivityTemplate = activityTemplates.find(
      (activityTemplate) => activityTemplate.id === event.target.value,
    );

    // we know this will never be the case but this satisfies TS
    if (!newActivityTemplate) return;

    onChangeActivityTemplate(newActivityTemplate as GetActivityTemplates_activityTemplates);

    showNotification({
      message: `Successfully selected ${newActivityTemplate.name}`,
    });
  };

  return (
    <InputSelect
      onChange={handleChangeActivityTemplate}
      options={activityTemplatesOptions}
      value={activityTemplateActive.id}
    />
  );
};
